import { render } from "./ExcludedFiltersLink.vue?vue&type=template&id=440a64c6&scoped=true"
import script from "./ExcludedFiltersLink.vue?vue&type=script&lang=js"
export * from "./ExcludedFiltersLink.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-440a64c6"]])

export default __exports__